import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CircleCall, AddAgent, AgentListBox } from '../layout/style';
export class AgentList extends Component {
  render() {
    const { image, name, message, time, dialNumber, callInfo, extraMessage } = this.props;
    return (
      <div className="hoverChat">
        <AgentListBox>
          <CircleCall style={{ cursor: 'pointer' }}>
            <a
              onClick={() => {
                dialNumber(callInfo);
              }}
            >
              <img src={image} />
            </a>
          </CircleCall>
          <h6>
            {name}
            <br />
            <span>{message}</span>
          </h6>
          <span>
            <AddAgent>
              <p>{time}</p>
            </AddAgent>
          </span>
          {/* </AddAgent> */}
        </AgentListBox>
      </div>
    );
  }
}
AgentList.contextTypes = {
  __: PropTypes.func
};

AgentList.props = {
  image: PropTypes.string,
  name: PropTypes.string,
  message: PropTypes.string,
  time: PropTypes.string
};

export default AgentList;



// WEBPACK FOOTER //
// src/dialpad/components/common/AgentList.js